import Account from '../api/Account';
import store from '../store';

export default async () => {
  const baseInfo = await Account.getBaseInfo();
  store.commit('setAccountData', baseInfo.data);
  if (baseInfo.data.users.length > 0 && !store.getters.currentUser) {
    const params = new URLSearchParams(window.location.search);
    const userId = params.get('userId');
    let firstUser;
    if (userId) {
      firstUser = store.getters.users.find(u => u.id === +userId);
    }
    if (!firstUser) {
      [firstUser] = store.getters.users;
    }
    // console.log('FU', store.getters.users);
    store.commit('setCurrentUserId', firstUser.id);
  }
};

export const managerName = (managerId) => {
  const manager = store.getters.managers.find(m => m.id === managerId);
  if (!manager) {
    return '';
  }

  return manager.name;
};
